/**
 * Gets the expected height for the `ListItem` or `SimpleListItem` based on the
 * addons and `secondaryText` props.
 *
 * Conversions:
 *
 * - height !== "auto" -&gt; height
 * - secondaryText or left/right addon is media/media-large  -&gt; "extra-large"
 * - left/right addon is avatar -&gt; "large"
 * - left/right addon is icon -&gt; "medium"
 * - no addons and no secondary text -&gt; "normal"
 *
 * @internal
 */
export function getListItemHeight(_a) {
    var _b = _a.height, height = _b === void 0 ? "auto" : _b, leftAddon = _a.leftAddon, _c = _a.leftAddonType, leftAddonType = _c === void 0 ? "icon" : _c, rightAddon = _a.rightAddon, _d = _a.rightAddonType, rightAddonType = _d === void 0 ? "icon" : _d, secondaryText = _a.secondaryText;
    if (height !== "auto") {
        return height;
    }
    var isIcon = (leftAddon && leftAddonType === "icon") ||
        (rightAddon && rightAddonType === "icon");
    var isAvatar = (leftAddon && leftAddonType === "avatar") ||
        (rightAddon && rightAddonType === "avatar");
    var isGraphic = (leftAddon &&
        (leftAddonType === "media" || leftAddonType === "large-media")) ||
        (rightAddon &&
            (rightAddonType === "media" || rightAddonType === "large-media"));
    // secondary text will always be extra large due to the default `line-height`
    if (isGraphic || secondaryText) {
        return "extra-large";
    }
    if (isAvatar) {
        return "large";
    }
    if (isIcon) {
        return "medium";
    }
    return "normal";
}
//# sourceMappingURL=getListItemHeight.js.map